import blogPosts from '../data/blog-posts.json';

export function renderBlogPost(container, slug) {
  if (!container) return;

  const postIndex = blogPosts.findIndex(p => p.slug === slug || p.id === slug);

  if (postIndex === -1) {
    container.innerHTML = `
      <div class="wt-container text-center" style="padding: 5rem 1rem;">
        <i class="fa-solid fa-triangle-exclamation" style="font-size:3rem; color:var(--accent-gold); margin-bottom:1rem;"></i>
        <h2>Article Not Found</h2>
        <p style="color:var(--text-secondary); margin-bottom:1.5rem;">We couldn't find the article you were looking for.</p>
        <a href="#blog" class="btn-primary">Back to Blog</a>
      </div>
    `;
    return;
  }

  const post = blogPosts[postIndex];
  const prevPost = postIndex < blogPosts.length - 1 ? blogPosts[postIndex + 1] : null;
  const nextPost = postIndex > 0 ? blogPosts[postIndex - 1] : null;

  container.innerHTML = `
    <div class="blog-post-page">
      <!-- Breadcrumb Nav -->
      <nav class="wt-container study-breadcrumb" aria-label="Breadcrumbs">
        <a href="#home"><i class="fa-solid fa-house"></i> Home</a>
        <span class="bc-sep">/</span>
        <a href="#blog">Blog</a>
        <span class="bc-sep">/</span>
        <span class="bc-current">${post.title}</span>
      </nav>

      <article class="wt-container blog-article-layout">
        <!-- Post Header -->
        <header class="blog-article-header text-center">
          <div class="blog-article-meta">
            <span class="blog-badge">${(post.categories && post.categories[0]) || 'Reflection'}</span>
            <span><i class="fa-regular fa-calendar"></i> ${post.formatted_date}</span>
            <span><i class="fa-regular fa-clock"></i> ${post.reading_time}</span>
          </div>

          <h1 class="blog-article-title">${post.title}</h1>
        </header>

        <!-- Post Content -->
        <div class="blog-article-content">
          ${post.content}
        </div>

        <!-- Post Footer / Tags -->
        <footer class="blog-article-footer">
          ${post.tags && post.tags.length > 0 ? `
            <div class="blog-article-tags">
              <strong>Tags:</strong>
              ${post.tags.map(t => `<span class="tag-pill">#${t}</span>`).join('')}
            </div>
          ` : ''}

          <!-- Prev / Next Post Links -->
          <div class="blog-nav-bar">
            ${prevPost ? `
              <a href="#blog/${prevPost.slug}" class="blog-nav-link prev">
                <small>&larr; Older Post</small>
                <span>${prevPost.title}</span>
              </a>
            ` : '<div></div>'}

            ${nextPost ? `
              <a href="#blog/${nextPost.slug}" class="blog-nav-link next">
                <small>Newer Post &rarr;</small>
                <span>${nextPost.title}</span>
              </a>
            ` : '<div></div>'}
          </div>

          <!-- Back to Blog Button -->
          <div class="text-center" style="margin-top:2.5rem;">
            <a href="#blog" class="btn-secondary">
              <i class="fa-solid fa-arrow-left"></i> Back to All Articles
            </a>
          </div>
        </footer>
      </article>
    </div>
  `;
}
